module.exports = __webpack_public_path__ + "img/member_2.16723394.jpg";